<template>
  <div class="product__descriptions product-descriptions" ref="wrapper">
    <div class="product-descriptions__content">
      <div class="product-descriptions__wrap" v-for="(description, i) in descriptions" :key="i">
        <div v-if="descriptions.length === 1"
            class="product-descriptions__item product-descriptions__item--single"
            :class="{'product-custom-description pcd': description.html_description}"
            v-html="description.description"></div>
        <div
          v-else
          class="product-descriptions__item"
          :class="{'reverse': i % 2 === 1}"
        >
          <div class="product-descriptions__text">
            <div class="product-descriptions__text-wrap">
              <h2 class="product-descriptions__title">
                {{ description.title }}
              </h2>
              <div class="product-descriptions__info" v-html="description.description"></div>
            </div>
          </div>
          <div class="product-descriptions__img">
            <img
              loading="lazy"
              data-force-load="true"
              :src="description.photo"
              :alt="`Характеристика товару «${description.title}» - фото №${i}`"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="product-descriptions__action">
      <button class="product-descriptions__more">
        <span>{{ $t('seo.main_show_more') }}</span>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7 9.70588L7.70667 9L12.3 13.5882L16.8933 9L17.6 9.70588L12.3 15L7 9.70588Z"
                fill="#909090"/>
        </svg>
      </button>
  </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ProductDescriptions',
  computed: {
    ...mapState({
      title: state => state.productInfo.productInfo.title,
      descriptions: state => state.productInfo.productInfo.descriptions
    })
  },
  mounted () {
    const wrapper = this.$refs.wrapper
    const productDesc = wrapper
    const productDescCont = wrapper.querySelector('.product-descriptions__content')
    const productDescMoreBth = wrapper.querySelector('.product-descriptions__more')
    const productDescMoreBthLabel = wrapper.querySelector('.product-descriptions__more span')
    const isOpen = () => productDesc.classList.contains('product-descriptions--open')
    const isTabletView = window.innerWidth > 768
    const isMobileView = !isTabletView

    if ((isMobileView && productDescCont.scrollHeight < 800) || (isTabletView && productDescCont.scrollHeight < 1200)) {
      productDescMoreBth.style.display = 'none'
      productDesc.classList.add('product-descriptions--open')
    }

    const tSafe = (key, fallback) => {
      const value = this.$t(key)
      return !value || value === key ? fallback : value
    }

    productDescMoreBth.addEventListener('click', (_) => {
      productDesc.classList.toggle('product-descriptions--open')
      if (isOpen()) {
        productDescCont.style.maxHeight = `${productDescCont.scrollHeight}px`
        productDescMoreBthLabel.textContent = tSafe('seo.main_show_less', 'Hide')
      } else {
        productDescCont.removeAttribute('style')
        productDescMoreBthLabel.textContent = tSafe('seo.main_show_more', 'Show more')

        productDesc.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    })
  }
}
</script>

<style scoped lang="sass">
.product-descriptions__item
  display: flex
  flex-flow: column-reverse
  align-items: center
  margin-bottom: 30px

  +mmin($tablet)
    flex-flow: row
    margin-bottom: 40px

  &--single
    display: block
    font-weight: 400

.product-descriptions__item.reverse
  +mmin($tablet)
    flex-flow: row-reverse

.product-descriptions__text,
.product-descriptions__img
  width: 100%
  text-align: left

  +mmin($tablet)
    width: 50%
    padding: 0 15px

.product-descriptions__text-wrap
  width: max-content
  max-width: 100%
  margin: 0 auto

.product-descriptions__title
  font-size: 24px
  font-weight: 400
  margin: 0 0 30px

.product-descriptions__info
  color: #4c4c4c
  font-size: 16px
  font-weight: 400
  line-height: 160%

  +mmin($tablet)
    max-width: 500px

.product-descriptions__img
  margin-bottom: 30px

  +mmin($tablet)
    margin-bottom: 0

  img
    width: 100%
    display: block

</style>

<style lang="scss">
.product-descriptions {
  &__content {
    max-height: 800px;
    position: relative;
    overflow: hidden;
    transition: max-height .3s ease-in-out;

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 170px;
      background: linear-gradient(184.44deg, hsla(0, 0%, 100%, 0) 3.61%, hsla(0, 0%, 100%, .469435) 44.84%, #fff 96.39%);
      transition: opacity .3s ease-in-out;
    }
  }

  &__action {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
  }

  &__more {
    padding: 10px 24px 10px 40px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 3px;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #333;
    background: #fff;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 24px;
      height: 24px;
      margin-left: 5px;
    }
  }

  &--open {
    .product-descriptions {
      &__content {
        &:after {
          opacity: 0;
          pointer-events: none;
        }
      }

      &__more {
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }

  @media screen and (min-width: 769px) {
    &__content {
      max-height: 1200px;
    }
  }
}
</style>
